import React from 'react';
import PropTypes from 'prop-types';
import styles from '../cardAndPreview/cardAndPreview.css';
import PreviewNavigationCard from '../cardAndPreview/PreviewNavigationCard';

function ApplicationPreview({
  activeApplicationName,
  decrementActiveApplication,
  incrementActiveApplication,
}) {
  return (
    <PreviewNavigationCard
      onLeftClick={decrementActiveApplication}
      onRightClick={incrementActiveApplication}
      testId="dmb-application"
    >
      <div className={styles.column}>
        <div
          className={styles.value}
          data-test-id="application-preview-application-name"
        >
          {activeApplicationName}
        </div>
      </div>
    </PreviewNavigationCard>
  );
}

ApplicationPreview.propTypes = {
  activeApplicationName: PropTypes.string.isRequired,
  decrementActiveApplication: PropTypes.func.isRequired,
  incrementActiveApplication: PropTypes.func.isRequired,
};

export default ApplicationPreview;
